export const API_URL = 'https://genesis.vision/api/v1.0';

export const RATE = `${API_URL}/rate?from=BTC&from=ETH&from=GVT&from=XRP&from=LTC&to=USD&to=BTC`;

export const ACCEPT_PARAM_NAME = 'ACCEPTCONSENT';

export const COOKIE_EXPIRES_TIME = 30 * 24 * 60 * 60 * 1000;
